import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useCallback, useContext, useLayoutEffect, useState } from "react";
export var AccordionContext = /*#__PURE__*/createContext(undefined);
export var AccordionProvider = function AccordionProvider(_ref) {
  var type = _ref.type,
    children = _ref.children,
    defaultOpenIds = _ref.defaultOpenIds;
  var _useState = useState(new Set(defaultOpenIds)),
    _useState2 = _slicedToArray(_useState, 2),
    openIds = _useState2[0],
    setOpenIds = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hydrated = _useState4[0],
    setHydrated = _useState4[1];
  useLayoutEffect(function () {
    setHydrated(true);
  }, [setHydrated]);
  var toggle = useCallback(function (id) {
    setOpenIds(function (prev) {
      var newSet = new Set(prev);
      if (type === "single") {
        // In single mode, only one can be open at a time
        return newSet.has(id) ? new Set() : new Set([id]);
      } else {
        // In multi mode, toggle the clicked one
        if (newSet.has(id)) {
          newSet["delete"](id);
        } else {
          newSet.add(id);
        }
        return newSet;
      }
    });
  }, [type]);
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      toggle: toggle,
      openIds: openIds,
      hydrated: hydrated
    }
  }, children);
};
export function useAccordionContext() {
  var context = useContext(AccordionContext);
  if (context === undefined) {
    throw new Error("useAccordionContext must be within AccordionContext Provider");
  }
  return context;
}